import { restrictions as config } from '@config';
import { isObject } from 'src/utils/deep-merge';
import { FolderRestrictionView } from 'src/views/menus/restrictions';

import DesignFacade from '../../../../facade/design/design';
import { instance as CompanyFactory } from '../../../../factory/company';
import { instance as LibraryFactory } from '../../../../factory/library';
import RestrictionsFactory from '../../../../factory/restrictions';

import ElementListView from './element-list/view';

module.exports = Backbone.mixin(Backbone.View.extend({
  type: null,
  basicHide: [],
  groupHeight: {},
  events: {
    'change .element-restriction-options .switch input': 'toggleSectionEvent',
    'change .element-restriction-sub-options .switch input': 'toggleSectionEvent',
    'change .restrictions.group .options .switch input': 'toggleRestrictionEvent',
    'change .replacement-options ul.options li input': 'toggleRestrictionEvent',
    'change .replacement-options ul.options li select': 'toggleRestrictionEvent',
    'click dt > a': 'categoryToggleEvent'
  },

  categoryToggleEvent: function (event, buttonTarget, forceActive = null) {
    const button = buttonTarget || event.currentTarget;
    const container = button.closest('dt');
    const isActive = container.classList.contains('active');

    if (forceActive === null) {
      isActive ? this._collapseList(container) : this._uncollapseList(container);
    } else {
      forceActive ? this._uncollapseList(container) : this._collapseList(container);
    }

    this.trigger('update');
  },

  toggleSectionEvent: function (event) {
    this.onSectionChange(event.currentTarget);
    this.remountLibraryFoldersSelect();
  },

  toggleRestrictionEvent: function (event) {
    this.persistOptionRestriction($(event.currentTarget));
    this.recalculateSectionHeight(event.currentTarget);
    this.remountLibraryFoldersSelect();
  },

  // TODO refactor and remove jquery
  onSectionChange: async function (input) {
    if (input.tagName.toLowerCase() !== 'input') return;

    const group = input.closest('.restrictions.group');
    const sectionName = group.getAttribute('data-name');

    if (sectionName || input.type === 'radio') {
      return RestrictionsFactory.getElementPermissions().then((elementPermissions) => {
        const permission = _(elementPermissions).findWhere({
          page_number: INKIVE.Tool._current_page_number,
          element_id: this.selection.id
        });

        let restrictions = permission ? JSON.parse(permission.restrictions) : {};

        if (input.checked) {
          const $options = $(input).closest('.element-restriction-sub-options').siblings('.replacement-options').children('.options');

          if ($options.length) {
            $options.find('input, select').trigger('change');
          } else {
            if (input.getAttribute('type') === 'radio') {
              const radioButtons = document.querySelectorAll('div[data-radiogroup="content-restriction"]');

              for (const button of radioButtons) {
                const name = button.getAttribute('data-name');
                if (name !== sectionName) restrictions = _(restrictions).omit(name);

                else if (!$(button).next().is(`.${name}-replacement-options`)) restrictions[name] = true;
              }
            } else {
              restrictions[sectionName] = input.classList.contains('is-object') ? {} : true;
            }

            RestrictionsFactory.setGlobalElementRestriction(
              this.selection.id, JSON.stringify(restrictions)
            );
          }
        } else {
          restrictions = _(restrictions).omit(sectionName);
          RestrictionsFactory.setGlobalElementRestriction(
            this.selection.id, JSON.stringify(restrictions)
          );
        }

        return null;
      });
    } else {
      _(this.el.querySelector('ul[name="' + group.getAttribute('data-field') + '-suboptions"] .switch input:checked')).each(function (input) {
        input.checked = false;
        this.onSectionChange(input);
        this.persistOptionRestriction($(input));
      }, this);
    }
  },

  beforeSaveElementRestrictions: function (restrictions, sectionName, name) {
    const newRestrictions = { ...restrictions };
    const sourcePropertyName = this.type === 'background' ? 'images' : 'source';

    if (sectionName === 'folder') {
      if (name === 'library_folder') {
        newRestrictions[sourcePropertyName] = {
          ...newRestrictions[sourcePropertyName],
          library_folder: newRestrictions.folder.library_folder
        };

        delete newRestrictions[sourcePropertyName].list;
      }
    }

    if (sectionName === sourcePropertyName) {
      if (name === 'list') {
        delete newRestrictions[sourcePropertyName].library_folder;
      }
    }

    // Text replace
    if (newRestrictions.basic?.text_change_content === false || newRestrictions.text_predefined_content === false) {
      delete newRestrictions.dictionary;
      delete newRestrictions.swearing;
      delete newRestrictions.source;
      delete newRestrictions.character_number;
      delete newRestrictions.numeric;
      delete newRestrictions.date;
      delete newRestrictions.currencies;
      delete newRestrictions.email;
    }

    // Image, video, icon, logo replace
    if (newRestrictions.basic?.image_content === false ||
        newRestrictions.basic?.video_replace === false ||
        newRestrictions.basic?.logo_replace === false ||
        newRestrictions.basic?.icon_replace === false
    ) {
      delete newRestrictions.source;
    }

    // background replace
    if (newRestrictions.basic?.image === false) {
      delete newRestrictions.images;
    }

    delete newRestrictions.folder;

    return newRestrictions;
  },

  savePermission: function () {
    RestrictionsFactory.save(true);
  },

  persistOptionRestriction: function ($option) {
    const section = $option.closest('.replacement-options').siblings('.restrictions.group') || $option.closest('.replacement-options').parent('.restrictions.group');
    let sectionName = section && section.data('name') ? section.data('name') : $option.closest('.restrictions.group').data('name');
    if (!sectionName && typeof sectionName !== 'undefined') {
      return;
    }

    sectionName = sectionName || 'basic';

    return RestrictionsFactory.getElementPermissions().then((elementPermissions) => {
      const permission = _(elementPermissions).findWhere({
        page_number: INKIVE.Tool._current_page_number,
        element_id: this.selection.id
      });

      const name = $option.attr('name');
      const superSection = $option.closest('.restrictions.group[data-field]').data('field');
      let restrictions = permission ? JSON.parse(permission.restrictions) : {};
      const value = this.getOptionValue($option);
      if (value?.itemsArray) return null;

      restrictions[sectionName] = restrictions[sectionName] || {};

      if (superSection && (sectionName === 'basic')) {
        if (!restrictions.basic) restrictions.basic = {};
        restrictions.basic[superSection] = !!value;
        if (superSection === 'color') {
          restrictions.basic[this.type + '_colour'] = !!value;
        }
      }

      if (name) restrictions[sectionName][name] = value;

      if (typeof value === 'undefined') {
        restrictions[sectionName] = _(restrictions[sectionName]).omit(name);
      }

      if (sectionName !== 'basic' && this.isEmptyOption(value)) {
        if (name) {
          if (name === 'text_change_content-suboptions') {
            delete restrictions[sectionName];
          } else if (name === 'text_predefined_content') {
            restrictions[sectionName] = false;
          } else {
            restrictions[sectionName] = _(restrictions[sectionName]).omit(name);
          }
        } else if (!_.size(restrictions[sectionName])) restrictions = _(restrictions).omit(sectionName);
      }

      restrictions = this.beforeSaveElementRestrictions(restrictions, sectionName, name);

      RestrictionsFactory.setGlobalElementRestriction(
        this.selection.id, JSON.stringify(restrictions)
      ).then(() => {
        this.savePermission();
      });

      return null;
    });
  },

  isEmptyOption: function (value) {
    return value === false ||
      value === null ||
      value === '' ||
      (isObject(value) && !_.size(value));
  },

  getOptionValue: function ($option) {
    if ($option.is('input[type="text"]') && $option.is('[name="library_folder"')) {
      try {
        return JSON.parse($option.val());
      } catch (e) {
        return {};
      }
    }
    if ($option.is('input[type="checkbox"]')) return $option.is(':checked');
    if ($option.is('input[type="radio"]')) return $option.is(':checked');
    if ($option.is('input[type="text"]')) return $option.val();
    if ($option.is('input[type="number"]')) return $option.val() === '' ? null : parseFloat($option.val());
    if ($option.is('select')) return $option.val();
  },

  initialize: async function (options) {
    this.selection = options.selection;
    _.bindAll(this, 'refresh');
    await this.refresh();
    this._expandAllList();
  },

  refresh: function () {
    return $.when(
      CompanyFactory.get(['groups']),
      RestrictionsFactory.getElementPermissions(),
      RestrictionsFactory.getTemplatePermissions(),
      LibraryFactory.get('palettes'),
      LibraryFactory.get('colors')
    ).then((groups, elementPermissions, templatePermissions, palettes, colors) => {
      this.groups = groups;
      this.elementPermissions = elementPermissions;
      this.templatePermissions = templatePermissions;
      this.groupHeight = {};

      const defaultPalette = {
        id: 0,
        name: INKIVE.TranslateHelper.translate('tool.library.default_palette'),
        colors
      };
      this.colorLibraryPalettes = [defaultPalette, ...palettes.map(({ data }) => data)];

      this.render();

      return null;
    });
  },

  _expandAllList: function () {
    const restrictionTabs = this.el.querySelectorAll('dt > a');

    restrictionTabs.forEach(node => {
      this.categoryToggleEvent(null, node, true);
    });
  },

  renderRestrictions: function () {
    let elementPermissions = _(this.elementPermissions).findWhere({
      page_number: INKIVE.Tool._current_page_number,
      element_id: this.selection.id
    });

    elementPermissions = elementPermissions ? JSON.parse(elementPermissions.restrictions) : {};

    this.renderDefaultRestrictions(elementPermissions);

    if (Object.keys(elementPermissions).length) {
      RestrictionsFactory.getTemplatePermissions().then((templatePermissions) => {
        const groups = [...this.el.querySelectorAll('.restrictions.group[data-field]')];
        groups.forEach((group) => {
          let field = group.dataset.field;
          if (field === 'color') field = `${this.type}_colour`;

          const restriction = elementPermissions.basic && typeof elementPermissions.basic[field] !== 'undefined'
            ? elementPermissions.basic[field]
            : templatePermissions[0][field];

          group.querySelector('.element-restriction-options .switch input[type="checkbox"]').checked = !!restriction;
        });
      });
    }

    const sections = [...this.el.querySelectorAll('.restrictions.group[data-name]')];
    sections.forEach((section) => {
      const sectionName = section.dataset.name;
      this._renderRestrictions(elementPermissions, sectionName);
    });
  },

  renderDefaultRestrictions: function (eRestrictions) {
    const regex = new RegExp('^' + this.type + '_.*');
    const basicPermissions = {};
    const permissions = this.templatePermissions[0];
    if (permissions) {
      Object.entries(permissions).forEach(([key, value]) => {
        if (key.match(regex)) basicPermissions[key] = value;
      });
    }

    this._renderRestrictions({ basic: basicPermissions }, 'basic');

    _.each(this.$el.find('.restrictions.group[data-field]'), _.bind(function (el) {
      const field = el.dataset.field;
      let r = basicPermissions[field];
      const input = el.querySelector('label.switch input[type="checkbox"]');

      if (!r && field === 'color') {
        r = basicPermissions[this.type + '_colour'];
      }

      input.checked = !!r;

      // TODO refactor and reduce the number of conditions
      r && _.isUndefined(eRestrictions.basic && eRestrictions.basic[field]) && this.onSectionChange(input);
    }, this));
  },

  _renderRestrictions: function (restrictions, sectionName) {
    const restriction = restrictions[sectionName];
    const groups = this.el.querySelectorAll('.restrictions.group[data-name="' + sectionName + '"]');
    let checked = isObject(restriction) ? !_.isEmpty(restriction) : restriction;
    if (restriction?.list) checked = !!restriction.list?.length;

    groups.forEach(group => {
      const checkbox = group.querySelector('.element-restriction-sub-options label.switch input[type="checkbox"]');
      const radio = group.querySelector('label.switch input[type="radio"]');

      checkbox && (checkbox.checked = checked);
      radio && (radio.checked = checked);

      if (this.type === 'background') {
        const bgCheckbox = group.querySelector('label.switch input[type="checkbox"]');
        bgCheckbox && (bgCheckbox.checked = restriction);
      }

      typeof restriction === 'object' && Object.entries(restriction).forEach(([key, value]) => {
        const parent = group.parentNode;

        group.querySelectorAll(`.element-restriction label.switch input[type="checkbox"][name="${key}"]`)
          .forEach(input => (input.checked = value));
        parent && parent.querySelectorAll(`.replacement-options input[type="number"][name="${key}"]`)
          .forEach(input => (input.value = value));
        group.querySelectorAll(`.replacement-options input[type="number"][name="${key}"]`)
          .forEach(input => (input.value = value));
        group.querySelectorAll(`.element-restriction label.switch input[type="text"][name="${key}"]`)
          .forEach(input => (input.value = value));
        parent && parent.querySelectorAll(`.replacement-options select[name="${key}"]`)
          .forEach(select => (select.value = value));
      });
    });
  },

  initColorsList: function (type) {
    type = type || '';
    const identifier = type + 'colorsListView';

    this[identifier] && this[identifier].remove();
    this[identifier] = new ElementListView({
      el: this.$el.find('.restrictions.group[data-name="' + type + 'colors"] li'),
      type: 'color',
      uuid: type + 'color'
    });

    this[identifier].on('change', _.bind(
      this.elementListChange, this, this[identifier]
    ));

    this[identifier].on('apply', function (color) {
      DesignFacade.set(this.type, { color });
    });
  },

  initLibraryColors: function (type) {
    type = type || '';
    const identifier = type + 'colorsLibraryView';
    this[identifier] && this[identifier].remove();

    this[identifier] = new ElementListView({
      el: this.$el.find('.restrictions.group[data-name="' + type + 'colors-library"] li'),
      type: 'colors_library',
      uuid: type + 'colors-library',
      colorLibraryPalettes: this.colorLibraryPalettes
    });

    this[identifier].on('change', _.bind(
      this.elementListChange, this, this[identifier]
    ));

    this[identifier].$el.find('select').on('change', _.bind(function () {
      this[identifier].setLibraryPaletteRestriction();
    }, this));
  },

  handleFolderSelected: function (folders) {
    const specifiedFolderRadio = this.el.querySelector('#element-restrictions-folder');

    if (!specifiedFolderRadio.checked) {
      return;
    }

    const nonEmptyFolders = folders.filter(Boolean);
    const $hiddenInput = this.$el.find('[data-name="folder"] input[name="library_folder"]');
    $hiddenInput.val(JSON.stringify(nonEmptyFolders));
    this.persistOptionRestriction($hiddenInput);
  },

  remountLibraryFoldersSelect () {
    this.folderRestrictionView?.closeApp();
    this.folderRestrictionView?.mountApp(this.mountAppOption);
  },

  initLibraryFolders: async function (type) {
    const elementPermissions = await RestrictionsFactory.getElementPermissions();
    const permission = elementPermissions.find(permission => {
      return permission.page_number === INKIVE.Tool._current_page_number &&
        permission.element_id === this.selection.id;
    });

    const restrictions = permission ? JSON.parse(permission.restrictions) : {};
    const selectedFolders = {};
    const sourcePropertyName = this.type === 'background' ? 'images' : 'source';

    if (restrictions?.[sourcePropertyName]?.library_folder?.length > 0) {
      restrictions[sourcePropertyName].library_folder.forEach(folder => {
        if (typeof folder === 'object' && folder.resourceId) {
          selectedFolders[folder.resourceId] = {
            ...folder
          };
        }

        if (typeof folder === 'string' || typeof folder === 'number') {
          if (folder) {
            selectedFolders[folder] = {
              resourceId: folder
            };
          }
        }
      });
    }

    if (!this.folderRestrictionView) {
      this.folderRestrictionView = FolderRestrictionView.createInstance();
    }

    this.mountAppOption = {
      type,
      handleFolderSelected: (folders) => this.handleFolderSelected(folders),
      workspace: CONFIG.company_domain,
      selectedFolders
    };

    this.folderRestrictionView.mountApp(this.mountAppOption);

    const node = document.querySelector(this.folderRestrictionView.targetNodeSelector);
    this.detectMountedFolderRestrictionView(node.parentElement, this.recalculateSectionHeight);

    INKIVE.EditorFacade
      .off('btn-menu.activate', this.handleTabButtonMenuClickedEvent, this)
      .once('btn-menu.activate', this.handleTabButtonMenuClickedEvent, this);
  },

  detectMountedFolderRestrictionView: function (el, recalculateSectionHeight) {
    function handleMutation (mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.target.id === 'react-library-folder-app' && mutation.addedNodes.length > 0) {
          recalculateSectionHeight(mutation.target);
        }
      }
    }
    this.observer = new MutationObserver(handleMutation);
    const options = { childList: true, subtree: true };
    this.observer.observe(el, options);
  },

  remove: function () {
    if (this.folderRestrictionView) {
      this.folderRestrictionView.closeApp();
    }
  },

  elementListChange: function (view) {
    const $input = view.$el.find('input');
    this.persistOptionRestriction($input);
  },

  _collapseList: function (container) {
    const icon = container.querySelector('icon');
    container.classList.remove('active');
    container.removeAttribute('style');

    if (icon.classList.contains('.files-icon')) return;

    icon.style.transform = 'rotate(180deg)';
  },

  _uncollapseList: function (container) {
    this.recalculateSectionHeight(container);
    const icon = container.querySelector('icon');

    if (icon.classList.contains('.files-icon')) return;

    icon.style.transform = 'rotate(270deg)';
  },

  recalculateSectionHeight: function (target) {
    const container = target.closest('dt');
    let height = config.sectionInitialHeight;
    // TODO: find a way to return margin;
    const margin = config.elementRestrictionsItemMargin;
    const list = container.querySelectorAll('dt > a, dt > ul');

    list.forEach(function (node) {
      if (node.nodeType === 1 && !node.classList.contains('hidden')) {
        height += node.offsetHeight;
        node.offsetHeight && node.tagName.toLowerCase() !== 'a' && (height += margin);
      }
    });

    container.classList.add('active');
    container.style.height = `${Math.round(height)}px`;
  },

  handleTabButtonMenuClickedEvent () {
    if (this.folderRestrictionView) {
      this.folderRestrictionView.closeApp();
    }
  },

  sortElementPermissions: function (key, permissions) {
    const order = ['position', 'size', 'rotation', 'duplication', 'deletion'];
    return permissions.sort((a, b) => {
      const indexA = order.findIndex(keyword => a.name === `${key}_${keyword}`);
      const indexB = order.findIndex(keyword => b.name === `${key}_${keyword}`);

      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });
  }
}), Backbone.Events);
